// Le seul point d'entrée pour modifier l'état : update(). Chaque modification
// prévient l'interface, qui se redessine au plus une fois par image.
import type { GameState } from './state';

type Listener = () => void;

let current: GameState | null = null;
const listeners = new Set<Listener>();
let renderScheduled = false;

export function getState(): GameState {
  if (!current) throw new Error("L'état du jeu n'est pas initialisé.");
  return current;
}

export function setState(next: GameState): void {
  current = next;
  notifyListeners();
}

export function update(mutator: (state: GameState) => void): void {
  mutator(getState());
  notifyListeners();
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Délai maximal avant de redessiner quand le navigateur ne fournit pas d'images. */
const RENDER_FALLBACK_MS = 100;

function notifyListeners(): void {
  if (renderScheduled) return;
  renderScheduled = true;
  const run = () => {
    if (!renderScheduled) return;
    renderScheduled = false;
    listeners.forEach((listener) => listener());
  };
  // requestAnimationFrame ne se déclenche pas quand la page n'est pas dessinée
  // (fenêtre masquée, aperçu intégré) : un minuteur prend alors le relais.
  if (typeof requestAnimationFrame === 'function') requestAnimationFrame(run);
  setTimeout(run, RENDER_FALLBACK_MS);
}
